module.exports = __webpack_public_path__ + "static/media/bridge.ddbb0a2d.svg";